import { createFileRoute } from '@tanstack/react-router'
import { PassportTab } from '../components/profile/PassportTab'
import { usePageMeta } from '../lib/meta'
export const Route = createFileRoute('/passport/$id')({ component: PassportPage })
function PassportPage() {
  const { id } = Route.useParams()
  usePageMeta('Agent passport', 'Permanent agent identity and history')
  return <PassportTab agentId={id} />
}
